import React from "react";
import { makeStyles, createStyles, CircularProgress, Theme } from "@material-ui/core";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    content: {
      display: "flex",
      justifyContent: "center",
      width: "100%",
      height: "100%",
    },
  })
);
interface ILoader {
  size?: number;
  margin?: string;
}
export function Loader({ size, margin }: ILoader) {
  const classes = useStyles();
  return (
    <div className={classes.content} style={{ marginLeft: margin }}>
      <CircularProgress size={size} style={{ margin: "auto 0px auto 0px" }} />
    </div>
  );
}
